import { DateTime } from 'luxon'

export interface HeaderDateProps {
  month: DateTime
}

const HeaderDate = ({ month }: HeaderDateProps) => (
  <div className='mt-[20px] font-mitr text-[14px] text-[#858baf] font-[300] mobile:text-center'>
    รายงานการขายระหว่าง
    <span className='text-secondary dark:text-dark-10 mx-[0.3rem]'>
      {month.startOf('month').toFormat('dd LLLL yyyy', { locale: 'th' })}
    </span>{' '}
    ถึง
    <span className='text-secondary dark:text-dark-10 mx-[0.3rem]'>
      {month.endOf('month').toFormat('dd LLLL yyyy', { locale: 'th' })}
    </span>
  </div>
)

export default HeaderDate
